import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export function get(id) {
  return axios
    .get(`v1/clients/${id}`, { params: { by: 'id' } })
    .then(response => response.data.client);
}
